import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'danger' | 'secondary' | 'outline'

const variantStyles: Record<Variant, string> = {
  primary:
    'bg-brand-blue text-white font-semibold shadow-xs hover:bg-brand-blue/90 hover:shadow-sm',
  danger:
    'bg-brand-red text-white font-semibold shadow-xs hover:bg-brand-red/90',
  secondary:
    'bg-surface-card text-text-secondary font-medium border border-gray-300 shadow-xs hover:bg-gray-50 hover:text-text-primary',
  outline:
    'bg-surface-card text-brand-blue font-semibold border border-brand-blue/30 hover:bg-brand-blue/5 hover:border-brand-blue/50',
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
}

export function Button({ variant = 'primary', className = '', ...props }: ButtonProps) {
  return (
    <button
      className={`
        inline-flex items-center justify-center gap-2
        rounded-lg px-4 py-2 text-sm
        transition-all duration-150
        disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none
        cursor-pointer outline-none
        ${variantStyles[variant]}
        ${className}
      `}
      {...props}
    />
  )
}
